<template>
  <div class="Foot">
    <div class="w">
      <div class="Foot-top">
        <img class="img" src="@/assets/img/logo2.png" alt="" />
        <div class="text1">联系方式</div>
        <div class="text2">15019801929</div>
        <div class="text3">惠州市西顿工业发展有限公司 粤ICP备07509439号</div>
      </div>
      <div class="Foot-bottom">粤公网安备44130202000046号</div>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
// PC样式
.Foot {
  width: 100%;
  margin: 0 auto;
  background: #ffffff;
  height: auto;

  .w {
    // width: 1280px;
    margin: 0 auto;
  }

  .Foot-top {
    width: 100%;
    background: #ffffff;
    padding-top: 48px;
    padding-bottom: 23px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .img {
      width: 232px;
      height: 29px;
      margin-bottom: 44px;
      object-fit: cover;
    }

    .text1 {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: 19px;
    }

    .text2 {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #e60000;
      margin-bottom: 11px;
    }

    .text3 {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-bottom: 23px;
    }
  }

  .Foot-bottom {
    width: 100%;
    height: 48px;
    background: #f9f9f9;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

// H5样式
@media (max-width: 767px) {
  .Foot {
    // position: absolute;
    // bottom: 0;
    width: 100%;
    margin: 0 auto;

    .w {
      // width: 1280px;
      margin: 0 auto;
    }

    .Foot-top {
      background: #ffffff;
      padding-top: 24px;
      padding-bottom: 15px;
      padding-left: 46px;
      padding-right: 46px;
      display: flex;
      flex-direction: column;
      align-items: center;

      .img {
        width: 116px;
        height: 15px;
        margin-bottom: 24px;
        object-fit: cover;
      }

      .text1 {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-bottom: 16px;
      }

      .text2 {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #e60000;
        margin-bottom: 12px;
      }

      .text3 {
        font-size: 12px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-bottom: 20px;
        text-align: center;
      }
    }

    .Foot-bottom {
      width: 100%;
      height: 48px;
      background: #f9f9f9;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
